// extracted by mini-css-extract-plugin
export default {"clearFiltersBtn":"ClearFiltersButton_clearFiltersBtn__r3nj3","clearFiltersIcon":"ClearFiltersButton_clearFiltersIcon__7eGUr"};